(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const bind = (scope = document) => {
    scope.querySelectorAll('[data-pc-brand]').forEach(brand => {
      if (brand.dataset.ready) return;
      brand.dataset.ready = 'true';
      const area = brand.closest('a');
      const art = brand.querySelector('img');
      if (!area || !art) return;
      let frame = 0, x = 0;
      const reset = () => { cancelAnimationFrame(frame); frame = 0; art.style.transform = ''; };
      area.addEventListener('pointermove', event => {
        if (reduced.matches || !fine.matches) return;
        const box = area.getBoundingClientRect();
        x = Math.max(-1, Math.min(1, (event.clientX - box.left) / box.width * 2 - 1));
        if (!frame) frame = requestAnimationFrame(() => {
          art.style.transform = 'translate(' + (x * 3).toFixed(1) + 'px,-2px) rotate(' + (x * 2).toFixed(1) + 'deg)';
          frame = 0;
        });
      }, {passive:true});
      area.addEventListener('pointerleave', reset);
      area.addEventListener('blur', reset);
      reduced.addEventListener('change', reset);
      fine.addEventListener('change', reset);
    });
    scope.querySelectorAll('[data-ps-textures]').forEach(guide => {
      if (guide.dataset.psReady) return;
      guide.dataset.psReady = 'true';
      const tabs = Array.from(guide.querySelectorAll('[data-ps-tab]'));
      const panels = Array.from(guide.querySelectorAll('[data-ps-panel]'));
      if (!tabs.length) return;
      const select = (tab, focus = false) => {
        tabs.forEach(item => {
          const chosen = item === tab;
          item.setAttribute('aria-selected', String(chosen));
          item.tabIndex = chosen ? 0 : -1;
        });
        panels.forEach(panel => {panel.hidden = panel.dataset.psPanel !== tab.dataset.psTab;});
        if (focus) tab.focus();
      };
      panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', 'ps-tab-' + panel.dataset.psPanel);
      });
      guide.querySelector('.ps-texture-tabs').hidden = false;
      select(tabs[0]);
      tabs.forEach((tab,index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') target = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') target = tabs[0];
          if (event.key === 'End') target = tabs[tabs.length - 1];
          if (target) {event.preventDefault(); select(target,true);}
        });
      });
    });
  };
  bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
